import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import { RoundedLoader } from "./sharedSkeletonParts";

interface HorizontalBarListSkeletonProps {
  items?: number;
  titleWidth?: number;
}

const TITLE_LINE_HEIGHT = 23;
const DEFAULT_TITLE_WIDTH = 240;
const BAR_HEIGHT = 30;
const BAR_RADIUS = 4;
const VALUE_LINE_HEIGHT = 20;
const VALUE_WIDTH = 90;

const BAR_WIDTHS = ["100%", "72%", "58%", "36%", "24%"];

export default function HorizontalBarListSkeleton({
  items = 5,
  titleWidth = DEFAULT_TITLE_WIDTH,
}: Readonly<HorizontalBarListSkeletonProps>) {
  return (
    <Card className="padding-y-25 padding-x-15 padding-x-25-sm display-flex flex-column height-100pct">
      <div className="padding-bottom-20">
        <ContentLoader className="display-block" height={TITLE_LINE_HEIGHT} width={titleWidth} />
      </div>
      <div
        data-testid="lista-barras-skeleton"
        className="flex-1-1 display-flex flex-column gap-5 padding-x-15 padding-bottom-15"
      >
        {Array.from({ length: items }, (_, index) => (
          <div key={index} className="display-flex align-items-center gap-10">
            <div className="flex-1-1 display-flex align-items-center gap-10 min-width-0">
              <RoundedLoader height={BAR_HEIGHT} width={BAR_WIDTHS[index % BAR_WIDTHS.length]} radius={BAR_RADIUS} />
              <ContentLoader className="display-block" height={VALUE_LINE_HEIGHT} width={VALUE_WIDTH} />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
